export default __webpack_public_path__ + "static/media/mail-at-white.740c26c0.svg";